import { render, staticRenderFns } from "./EcommerceComponent.vue?vue&type=template&id=592481f3"
import script from "./EcommerceComponent.vue?vue&type=script&lang=js"
export * from "./EcommerceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports